<template>
    <div class="toggle-container filters-container" :key="keyToReRender">
        <div class="panel style1 arrow-right">
            <h4 class="panel-title">
                <a data-toggle="collapse" href="#modify-search-panel" class="">{{ modifysearch[getCurrentLocale] }}</a>
            </h4>

            <div id="modify-search-panel" class="panel-collapse collapse in">
                <div class="panel-content">
                    <div class="search-content">
                        <form @submit.prevent="onSubmit">
                            <div class="form-group">
                                <label>{{ departuredate[getCurrentLocale] }}:</label>
                                 <vue-pikaday
                                    v-model="date_from"
                                    name="date_from"
                                    :placeholder="pickdeparturedate[getCurrentLocale]"
                                    class="input-text full-width"
                                    :options="options[getCurrentLocale]"
                                    :value="start"
                                 />
                            </div>

                            <div class="form-group">
                                <label>{{ returndate[getCurrentLocale] }}:</label>
                                 <vue-pikaday
                                    v-model="date_to"
                                    name="date_to"
                                    :placeholder="pickreturndate[getCurrentLocale]"
                                    class="input-text full-width"
                                    :options="options[getCurrentLocale]"
                                    :value="end"
                                 />
                            </div>
                            <br />
                            <button class="btn-medium icon-check uppercase full-width">{{ searchagain[getCurrentLocale] }}</button>
                        </form>
                    </div>
                </div>
            </div>
        </div>
    </div>
</template>

<script>
    import { mapGetters } from 'vuex';
    import { mapActions } from 'vuex';

    import moment from 'moment';


    export default {

        /* >>> *************************************************************** / /* Data */
        data: function() {

            return {
                // >>> ------------------------------------
                modifysearch: {
                    en: 'Find bookings:',
                    de: 'Buchungen finden:',
                },
                departuredate: {
                    en: 'Booking Date (from)',
                    de: 'Buchungs Datum (von)',
                },
                pickdeparturedate: {
                    en: 'Bookings from...',
                    de: 'Buchungen ab...',
                },
                // >>> ------------------------------------
                returndate: {
                    en: 'Booking Date (to)',
                    de: 'Buchungs Datum (bis)',
                },
                pickreturndate: {
                    en: 'Bookings to...',
                    de: 'Buchungen bis...',
                },
                // >>> ------------------------------------
                searchagain: {
                    en: 'Find bookings',
                    de: 'Buchungen finden',
                },
                // currentLocale: 'de',
                // >>> --------------------------
                date_from: null,
                date_to: null,
                start: moment(),
                end: moment(),


                options: {
                    en: {
                        format: 'DD.MM.YYYY',
                        i18n: {
                            previousMonth : 'Previous Month',
                            nextMonth     : 'Next Month',
                            months        : ['January','February','March','April','May','June','July','August','September','October','November','December'],
                            weekdays      : ['Sunday','Monday','Tuesday','Wednesday','Thursday','Friday','Saturday'],
                            weekdaysShort : ['Sun','Mon','Tue','Wed','Thu','Fri','Sat']
                        }
                    },
                    de: {
                        format: 'DD.MM.YYYY',
                        i18n: {
                            previousMonth : 'Vorheriger Monat',
                            nextMonth     : 'Nächster Monat',
                            months        : ['Januar','Februar','März','April','Mai','Juni','Juli','August','September','Oktober','November','Dezember'],
                            weekdays      : ['Sonntag',' Montag',' Dienstag',' Mittwoch',' Donnerstag',' Freitag',' Samstag'],
                            weekdaysShort : ['SO','MO','DI','MI','DO','FR','SA']
                        }
                    },
                    // format: 'DD.MM.YYYY',
                    // minDate: moment().toDate(),
                    // maxDate: moment().add(7, 'days').toDate()
                },
                // >>> --------------------------
                keyToReRender: 0
            };

        }, // eof data()
        /* <<< ****************************************************************/



        /* >>> *************************************************************** / /* Computed */
        computed: {

            ...mapGetters([
                'getCurrentLocale',
                'getFlagSharedAgencyLoggedIn', // is Agency logged in?
                'getSharedAgencyLoginResultsAgencyObject',
                'get_sharedAgencyGetBookings',
            ]),

        }, // eof computed{}
        /* <<< ****************************************************************/



        /* >>> *************************************************************** /  /* LifeCycles */
        /***********************************************************************
        * Lifecyclehook::updated
        *
        * Desc:
        * Note:
        *
        */
        updated: function() {

            this.$nextTick(function () {
                if (this.keyToReRender !== 0) {
                    // console.log('rerendered!!! ');
                }
            });

        }, // eof updated()


        /***********************************************************************
        * Lifecyclehook::mounted
        *
        * Desc:
        * Note:
        *
        */
        mounted: function() {

            this.date_from = moment().subtract(3, 'months').toString();
            this.date_to = moment().toString();

            this.keyToReRender += 1;

        }, // eof mounted()
        /* <<< ****************************************************************/



        /* >>> *************************************************************** / /* Methods */
        methods: {

            ...mapActions([
                'actn_call_GetAgencyBookings',
            ]),


            /******************************************************************* 'Listeners - Common'
            * Listeners:
            *******************************************************************/
            /*******************************************************************
            * onSubmit()
            *
            * Desc: ModifySearchBox Submit.
            * Note:
            *
            */
            onSubmit: function(submitEvent) {

                var me = this,
                    agencyObject = {},
                    date_from = null,
                    date_to = null,
                    agencyObjectFromLS = JSON.parse(this.getSharedAgencyLoginResultsAgencyObject);


                me.$toc('>>> /components/agency/pagecontent/ModifySearchBox >>> onSubmit');
                date_from = submitEvent.target.elements.date_from.value.split('.');
                date_to = submitEvent.target.elements.date_to.value.split('.');

                if (this.getFlagSharedAgencyLoggedIn === true) {
                    agencyObject = {
                        "idAgency": agencyObjectFromLS.idCustomer,
                        "fromDate": String(moment(date_from[2] + '-' + date_from[1] + '-' + date_from[0]).format('YYYY-MM-DDT00:00:01')),
                        "toDate": String(moment(date_to[2] + '-' + date_to[1] + '-' + date_to[0]).format('YYYY-MM-DDT23:59:59')),
                    };

                    this.actn_call_GetAgencyBookings(agencyObject);
                }

            }, // eof onSubmit()




            /*******************************************************************
            * Utilities:
            *******************************************************************/
            /*******************************************************************
            * forceRerender()
            *
            * Desc: Simply change the Components :key to force rerendering.
            * Note:
            *
            */
            forceRerender: function() {

                var me = this;


                me.$toc('>>> booking/flightsearch/ModifySearchBox.vue >>> forceRerender');
                this.keyToReRender += 1;

            }, // eof forceRerender()

        }, // eof methods()
        /* <<< ****************************************************************/

    };
</script>

